import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import svgMap from '../svgs/Common/svgMap';
import { DialogText } from './FormattedText';

const SingelMessageContainer = styled.li`
    position:relative;
    width:271px;
    margin: 10px 0px 0 0px;
`;

const DialogIcon = styled.img`
    position: absolute;
    width: 23px;
    height: 23px;
    left: -30;
    object-fit: contain;
`;

const DialogsContainer = styled.ul`
    margin: 0;
    padding: 0;
    list-style-type: none;
    position:absolute;
    top: ${({ top }) => top || 223};
    left: ${({ left }) => left || 508};
`;

export const ProgressDialogs = props => (
  <DialogsContainer {...props}>
    {props.dialogs.map((m, index) => {
      const iconSvg = m.goalType === 'next' ? svgMap.BulletCarrot : svgMap.BulletCheck;
      return (
        <SingelMessageContainer key={`bullet point ${index + 1}`}>
          <DialogIcon src={iconSvg} alt="" />
          <DialogText index={index}>{m.text}</DialogText>
        </SingelMessageContainer>
      );
    })}
  </DialogsContainer>
);

ProgressDialogs.propTypes = {
  dialogs: PropTypes.array.isRequired,
};

export default ProgressDialogs;
